import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { DndProvider } from 'react-dnd-multi-backend';
import HTML5toTouch from 'react-dnd-multi-backend/dist/esm/HTML5toTouch';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';

import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

import { AnnotateDragPreview } from 'components/organisms/questions/annotateAdvanced/AnnotatePin/AnnotateDragPreview';
// import { unregister } from './registerServiceWorker';
import {
  version,
  DATA_DOG_RUM_SERVICE,
  DATA_DOG_RUM_APPLICATION_ID,
  DATA_DOG_RUM_CLIENT_TOKEN,
  DATA_DOG_RUM_ENV,
} from './constants';
import App from './App';
import { getParsedTokenOrMakeWithExpiry } from './utils/utils';

import './assets-v2/stylesheets/style.scss';

import store, { history } from './store';

const dataDogConfig = {
  applicationId: DATA_DOG_RUM_APPLICATION_ID,
  clientToken: DATA_DOG_RUM_CLIENT_TOKEN,
  site: 'datadoghq.eu',
  service: DATA_DOG_RUM_SERVICE,
  env: DATA_DOG_RUM_ENV,
  version,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackResources: true,
  trackUserInteractions: true,
  trackLongTasks: true,
  plugins: [reactPlugin({ router: false })],
};
// console.log('Initializing Datadog RUM with config:', dataDogConfig);
datadogRum.init(dataDogConfig);

// handle tokens without expiry date (backwards compatibility)
getParsedTokenOrMakeWithExpiry();

const router = (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <DndProvider options={HTML5toTouch}>
        <AnnotateDragPreview />
        <App />
      </DndProvider>
    </ConnectedRouter>
  </Provider>
);

render(router, document.getElementById('root'));

// unregister();
